import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


const AdminPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.user_type !== 2) {
      navigate('/unauthorized');
      return;
    }
  fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/api/users`)
      .then(res => res.json())
      .then(data => {
        setUsers(data.users || []);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load users.');
        setLoading(false);
      });
  }, [navigate]);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this user? This action cannot be undone.')) return;
    setDeletingId(id);
    setError('');
    try {
  const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/api/users/${id}`, {
        method: 'DELETE',
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setUsers(users.filter(u => u.id !== id));
      } else {
        setError(data.message || 'Failed to delete user.');
      }
    } catch {
      setError('Failed to delete user.');
    }
    setDeletingId(null);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Admin - User Management</h2>
      {loading ? (
        <div style={styles.loading}>Loading users...</div>
      ) : (
        <>
          {error && <div style={styles.error}>{error}</div>}
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>ID</th>
                <th style={styles.th}>First Name</th>
                <th style={styles.th}>Last Name</th>
                <th style={styles.th}>Email</th>
                <th style={styles.th}>User Type</th>
                <th style={styles.th}>Actions to Delete/Disable</th>
           
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id}>
                  <td style={styles.td}>{user.id}</td>
                  <td style={styles.td}>{user.firstName}</td>
                  <td style={styles.td}>{user.lastName}</td>
                  <td style={styles.td}>{user.email}</td>
                  <td style={styles.td}>
                    {user.user_type === 1
                      ? 'Customer'
                      : user.user_type === 2
                      ? 'Admin'
                      : user.user_type === 3
                      ? 'Vendor'
                      : 'Unknown'}
                  </td>
                  <td style={styles.td}>
                    {user.user_type === 2 ? null : (
                      <>
                        <button
                          style={styles.deleteBtn}
                          onClick={() => handleDelete(user.id)}
                          disabled={deletingId === user.id}
                        >
                          {deletingId === user.id ? 'Deleting...' : 'Delete'}
                        </button>
                        
                        {/* Toggle Switch for is_disabled */}
                        <label style={styles.switchLabel}>
                          <input
                            type="checkbox"
                            checked={user.is_disabled}
                            onChange={async (e) => {
                              const newDisabled = e.target.checked;
                              const action = newDisabled ? 'disable' : 'enable';
                              if (!window.confirm(`Are you sure you want to ${action} this user?`)) {
                                e.preventDefault();
                                return;
                              }
                              try {
                                const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/api/users/${user.id}/disable`, {
                                  method: 'PUT',
                                  headers: { 'Content-Type': 'application/json' },
                                  body: JSON.stringify({ is_disabled: newDisabled }),
                                });
                                const data = await res.json();
                                if (res.ok && data.success) {
                                  setUsers(prev =>
                                    prev.map(u =>
                                      u.id === user.id ? { ...u, is_disabled: newDisabled } : u
                                    )
                                  );
                                } else {
                                  setError(data.message || 'Failed to update user status.');
                                }
                              } catch {
                                setError('Failed to update user status.');
                              }
                            }}
                            disabled={deletingId === user.id}
                            style={styles.switchInput}
                          />
                          <span
                            style={{
                              ...styles.switchSlider,
                              backgroundColor: user.is_disabled ? '#d32f2f' : '#388e3c' , // green if not disabled, red if disabled
                            }}
                          ></span>
                        </label>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    marginBottom: '28px',
    color: '#4078c0',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  loading: {
    textAlign: 'center',
    color: '#4078c0',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginTop: '40px',
    letterSpacing: '1px',
  },
  error: {
    color: '#d32f2f',
    textAlign: 'center',
    marginBottom: '18px',
    fontWeight: 'bold',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '18px',
    fontSize: '1.05rem',
  },
  th: {
    background: '#f5f6fa',
    color: '#8d6e36',
    fontWeight: 'bold',
    fontSize: '1.08rem',
    padding: '12px 8px',
    borderBottom: '2px solid #e0cfa0',
    textAlign: 'left',
  },
  td: {
    padding: '10px 8px',
    borderBottom: '1px solid #e0cfa0',
    fontSize: '1.05rem',
    textAlign: 'left',
    verticalAlign: 'top',
  },
  deleteBtn: {
    background: '#d32f2f',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '6px 16px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
  },
  switchLabel: {
    display: 'inline-block',
    width: '50px',
    height: '28px',
    position: 'relative',
    marginLeft: '8px',
  },
  switchInput: {
    opacity: 0,
    width: '0',
    height: '0',
  },
  switchSlider: {
    position: 'absolute',
    cursor: 'pointer',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: '#ccc', // default
    transition: '.4s',
    borderRadius: '28px',
    // Add the toggle circle
    '::before': {
      position: 'absolute',
      content: '""',
      height: '22px',
      width: '22px',
      left: '3px',
      bottom: '3px',
      backgroundColor: '#fff',
      transition: '.4s',
      borderRadius: '50%',
    },
  },
};


export default AdminPage;